import { render, staticRenderFns } from "./AudioLinkInput.vue?vue&type=template&id=dbef701c&scoped=true"
import script from "./AudioLinkInput.vue?vue&type=script&lang=js"
export * from "./AudioLinkInput.vue?vue&type=script&lang=js"
import style0 from "./AudioLinkInput.vue?vue&type=style&index=0&id=dbef701c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbef701c",
  null
  
)

export default component.exports